export const storeSetupOutlet = 'store-setup';
